import { IClassname } from '@/lib/shared/model/classname';

export const SuitableForEvents = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.30396 2.62207L30.696 11.0959"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.35815 2.92676L3.49678 10.6019C3.51444 10.7226 3.56624 10.8356 3.64607 10.9278C3.72591 11.0199 3.83044 11.0873 3.94734 11.122C4.06423 11.1566 4.1886 11.1571 4.30576 11.1234C4.42293 11.0897 4.528 11.0231 4.60857 10.9316L9.78029 5.06599"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1497 5.74902L13.2257 13.4536C13.2425 13.5741 13.2935 13.6873 13.3725 13.7799C13.4515 13.8724 13.5553 13.9405 13.6717 13.9761C13.7881 14.0117 13.9122 14.0133 14.0295 13.9807C14.1467 13.9481 14.2523 13.8827 14.3336 13.7922L19.6229 7.89976"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.9294 8.56836L23.0054 16.287C23.0221 16.4078 23.073 16.5213 23.1521 16.6141C23.2312 16.7069 23.3352 16.7752 23.4518 16.8108C23.5685 16.8464 23.6929 16.8479 23.8103 16.8151C23.9278 16.7823 24.0334 16.7165 24.1147 16.6256L29.4104 10.7255"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.30396 22.4302L30.696 19.1357"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.83936 22.37L5.75873 29.0804C5.82053 29.1844 5.91063 29.2688 6.01852 29.3237C6.12642 29.3785 6.24768 29.4016 6.36818 29.3902C6.48869 29.3788 6.60348 29.3335 6.6992 29.2594C6.79491 29.1853 6.86762 29.0856 6.90885 28.9718L9.56692 21.5049"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3271 21.1938L16.2759 27.9591C16.3377 28.0632 16.4278 28.1475 16.5357 28.2024C16.6436 28.2573 16.7649 28.2803 16.8854 28.269C17.0059 28.2576 17.1207 28.2122 17.2164 28.1381C17.3121 28.064 17.3848 27.9643 17.426 27.8505L20.1097 20.3223"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.313 20.0745L26.2119 26.7542C26.2737 26.8582 26.3638 26.9426 26.4717 26.9975C26.5796 27.0523 26.7009 27.0754 26.8214 27.064C26.9419 27.0527 27.0567 27.0073 27.1524 26.9332C27.2481 26.8591 27.3208 26.7594 27.362 26.6456L30.0048 19.2119"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
